import { defineMessages } from 'react-intl';
const messages = defineMessages({
    noMediaDevicesFound: {
        id: 'app.contexts.MediaContext.noMediaDevicesFound',
        defaultMessage: 'No media devices found.',
    },
    deviceAccessDenied: {
        id: 'app.contexts.MediaContext.deviceAccessDenied',
        defaultMessage: 'We were unable to access your camera or microphone. Please allow access in your browser settings.',
    },
    deviceInUse: {
        id: 'app.contexts.MediaContext.deviceInUse',
        defaultMessage: 'Your camera or microphone is in use by another application. Please close it and try again.',
    },
    deviceConstraintsNotSatisfied: {
        id: 'app.contexts.MediaContext.deviceConstraintsNotSatisfied',
        defaultMessage: "Your camera or microphone doesn't support the required settings. Please try a different device.",
    },
    recordingNotSupported: {
        id: 'app.contexts.MediaContext.recordingNotSupported',
        defaultMessage: 'Recording is not supported in this browser.',
    },
    mediaStreamInactive: {
        id: 'app.contexts.MediaContext.mediaStreamInactive',
        defaultMessage: 'Media stream is not active.',
    },
    noMediaStream: {
        id: 'app.contexts.MediaContext.noMediaStream',
        defaultMessage: 'No media stream found.',
    },
});
export default messages;
